import runningLocal from '../util/local'

// General
export const awsRegion = 'eu-west-1'
export const awsCognitoRegion = 'eu-central-1'

// Cognito
export const identityPoolRegion = awsCognitoRegion
export const identityPoolId = identityPoolRegion + ':45217f05-5a25-48bb-b178-a494e786cf1a'
export const userPoolId = 'eu-central-1_9EZefIqbT'
export const appId = '4sjpim763fek7fhbg1d8chv06e'
export const userPoolProvider = 'cognito-idp.' + awsCognitoRegion + '.amazonaws.com/' + userPoolId

const apigBaseUrlTest = 'https://z862iv4yhg.execute-api.eu-west-1.amazonaws.com/dev'
const apigBaseUrlProcution ='https://api.runthemarenostrum.com'

// API Gateway
export const apigRegion = awsRegion
export const apigBaseUrl = runningLocal ? apigBaseUrlTest : apigBaseUrlProcution